import React, { useEffect } from "react";
import Header from "../components/Header";
import Body from "../components/Body";
import { MainRoutes } from "../routes/routes";
import { generateStateAndNonce } from "../redux/token/tokenSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { parse } from "query-string";
import { GetLocalStore, LocalStore, RemoveAdminLocalStore } from "../utils/storage";
import axios from "axios";
import { setStorePermissions, storeSet } from "../redux/store/storeSlice";
import { oktaLoginAuth, useAuthLogout} from "../api/oidcApi";

const AdminLayout = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { state, nonce, accessToken } = useSelector((state) => state?.token);
  const dispatch = useDispatch();
  const handleLogout = useAuthLogout();
  const generateParams = () => {
    dispatch(generateStateAndNonce());
  };


  useEffect(() => {
    const path = location?.pathname;
    if (searchParams.get('id')) {
      LocalStore("storeVal", searchParams.get('id'));
    }

    // Check if there's an access token in the hash
    const token = location?.hash?.split('&')?.[0]?.replace('#id_token=', '');
    if (token) {
      LocalStore("token", token);
      return; // Return to avoid further redirection
    }

    // Check if there's no access token
    if (!accessToken && path !== "/403") {
      const hash = location.hash;
      const response = parse(hash);
      if (path === "/okta" && !response.error) {
        LocalStore("path", "/");
      } else {
        LocalStore("path", path);
      } 
      oktaLoginAuth({ state, nonce });     
    }
  }, [accessToken, state]);

  axios.interceptors.request.use(
    (config) => {
      // Modify the request configuration or add headers
      config.headers['Authorization'] = GetLocalStore('token');
      return config;
    },
    (error) => {
      // Handle request errors
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error?.response?.status;
      const requestUrl = error.config?.url || '';
      const isPLToolEndpoint = requestUrl.includes('plsaveperiod') || requestUrl.includes('plupdatestatus') || requestUrl.includes('plbootstrap') || requestUrl.includes('plcustomschema') || requestUrl.includes('plreopenrequest') || requestUrl.includes('plsaleskeysvalues');
      if ((status === 403 || status === 401) && !isPLToolEndpoint) {
        // console.log(status,"Status")
        // RemoveAllLocalStore()
        RemoveAdminLocalStore()
        dispatch(storeSet(""));
        dispatch(setStorePermissions(""));
        handleLogout();
        // authLogout({
        //   id_token_hint: '',
        //   state: "",
        // });
      }
      return Promise.reject(error);
    }
  )


  return (
    <div className="min-h-full bg-neutral-light relative">
      {location?.pathname === "/auth" ? null : <Header />}
      <Body MainRoutes={MainRoutes} />

    </div>
  );
};

export default AdminLayout;
